<template>
	<div id="app" class="site-container">
		<loading-bar/>
		<Header/>

		<router-view/>
	</div>
</template>
<script>

	import Header from '@/components/layout/Header';
	import LoadingBar from '@/components/layout/LoadingBar';

	export default {
		name: 'App',
		components:{
			Header,
			LoadingBar
		}
	}
</script>

<style lang="scss">
	@import "assets/scss/main";
</style>
